export default {"src":"/_next/static/media/result_count.65d6de45.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};